import { Button } from "@/components/ui/button";
import { Trash2, Plus } from "lucide-react";

interface PhotoReviewScreenProps {
  imageUrls: string[];
  onDelete: (index: number) => void;
  onAddMore: () => void;
  onNext: () => void;
}

export default function PhotoReviewScreen({ imageUrls, onDelete, onAddMore, onNext }: PhotoReviewScreenProps) {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      {/* Header */}
      <div className="p-6 border-b">
        <h1 className="text-2xl font-bold text-foreground">Review Photos</h1>
        <p className="text-muted-foreground">
          {imageUrls.length} photo{imageUrls.length !== 1 ? 's' : ''} captured
        </p>
      </div>

      {/* Photos grid */}
      <div className="flex-1 overflow-y-auto p-6">
        <div className="space-y-4 max-w-2xl mx-auto">
          {imageUrls.map((url, index) => (
            <div key={index} className="relative group">
              <img 
                src={url} 
                alt={`Receipt ${index + 1}`}
                className="w-full rounded-lg shadow-md"
              />
              <Button
                onClick={() => onDelete(index)}
                variant="destructive"
                size="icon"
                className="absolute top-2 right-2 h-10 w-10 rounded-full opacity-0 group-hover:opacity-100 transition-opacity"
              >
                <Trash2 className="h-5 w-5" />
              </Button>
              <div className="absolute bottom-2 left-2 bg-black/60 text-white px-3 py-1 rounded-full text-sm">
                Photo {index + 1} of {imageUrls.length}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Actions */}
      <div className="p-6 border-t space-y-3">
        <Button
          onClick={onAddMore}
          variant="outline"
          className="w-full h-12"
          disabled={imageUrls.length >= 10}
        >
          <Plus className="mr-2 h-5 w-5" />
          Add another photo
        </Button>
        <Button
          onClick={onNext}
          className="w-full h-12 bg-[#22c25c] hover:bg-[#1ea550] text-white text-base font-semibold"
        >
          Next
        </Button>
      </div>
    </div>
  );
}
